import Inventaris from '../../views/Inventaris/Inventaris.view';

export default Inventaris;
